module.exports = __webpack_public_path__ + "img/L_309_0.6a2f58d6.png";